import { PaperPlaneTiltIcon } from '@phosphor-icons/react';
import React, { useState } from 'react';

import { Button } from '@/components/ui/button';
import { useDialogContentContainer } from '@/components/ui/dialog';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { listPlatformNames } from '@/lib/posts/unsent-platforms';

interface UnsentPlatformsActionProps {
  platformLabels: readonly string[];
  sentLabels: readonly string[];
  isSending: boolean;
  onConfirm: () => void | Promise<void>;
}

export const UnsentPlatformsAction: React.FC<UnsentPlatformsActionProps> = ({
  platformLabels,
  sentLabels,
  isSending,
  onConfirm,
}) => {
  const [open, setOpen] = useState(false);
  const container = useDialogContentContainer();
  const names = listPlatformNames(platformLabels);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="neutral" size="sm" disabled={isSending}>
          <PaperPlaneTiltIcon className="size-3.5" weight="regular" />
          <span>{isSending ? 'Sending...' : `Send to ${names}`}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" container={container} className="w-80 space-y-3 p-3">
        <div className="space-y-1">
          <p className="text-caption font-medium text-foreground">{`Send to ${names} now?`}</p>
          <p className="text-detail leading-snug text-muted-foreground">
            This posts immediately and can&apos;t be undone.
            {sentLabels.length > 0
              ? ` ${listPlatformNames(sentLabels)} ${sentLabels.length === 1 ? 'is' : 'are'} not sent again.`
              : ''}
          </p>
        </div>
        <Button
          variant="neutral"
          size="sm"
          className="w-full"
          disabled={isSending}
          onClick={() => {
            setOpen(false);
            void onConfirm();
          }}
        >
          <PaperPlaneTiltIcon className="size-3.5" weight="bold" />
          Send now
        </Button>
      </PopoverContent>
    </Popover>
  );
};
